import { SliderMark } from "@mui/material";
import { CSSProperties, ReactNode } from "react";
import { Mark } from "./CustomSlider";

const CustomMark: React.FC<CustomMarkProps> = ({
  dataIndex,
  style,
  min,
  max,
  marks,
  children,
  ...other
}) => {
  function getBackgroundColor() {
    switch (dataIndex) {
      case 0:
        return "#ac3333";
      case 1:
        return "#ceaa73";
      case 2:
        return "#ceaa73";
      case 3:
        return "#ac3333";

      default:
        return "#ac3333";
    }
  }

  function getExtraTrack() {
    if (marks.length > dataIndex + 1) {
      const maxDiff = max - min;
      const markValue = marks[dataIndex].value;
      const nextMarkValue = marks[dataIndex + 1].value;

      const width = ((nextMarkValue - markValue) * 100) / maxDiff;

      switch (dataIndex) {
        case 0:
        case 2:
          return (
            <div
              style={{
                ...style,
                backgroundColor: "#ac3333",
                height: "5px",
                width: `${width}%`,
              }}
              className="extra-track"
            ></div>
          );
        case 1:
        case 3:
        default:
          return <></>;
      }
    }

    return <></>;
  }

  return (
    <>
      {getExtraTrack()}

      <SliderMark
        {...other}
        className="custom-mark"
        style={{
          ...style,
          backgroundColor: getBackgroundColor(),
        }}
      >
        {children}
      </SliderMark>
    </>
  );
};

export default CustomMark;

export interface CustomMarkProps {
  dataIndex: number;
  style: CSSProperties;
  min: number;
  max: number;
  marks: Mark[];
  children?: ReactNode;
}
